import React,{ useState, useEffect} from 'react';
import { Spin, Empty } from 'antd';
import { getattachmentList } from '../../../../actions/majorProjects' ;
import Scrollbars from 'react-custom-scrollbars';
import UploadItem from '../../../resource-wrap/common-wrap/pictureItem/upLoadItem';
import task from '../../images/task.png'

//美工附件页面
const Attachment = (props) => {

    const [loading, setLoading] = useState(false)
    const [attachmentList, setAttachmentList] = useState([])

    useEffect(() => {
        search()
    },[])

    const search = () => {
        let formData={
        //   start: 1,
        //   size: 99999999,
          id: props.id, ///项目id
          resourceType: 9
      }
      setLoading(true)
      getattachmentList(formData,function(res){
          if(res.code === 0){
            setLoading(false)
            let data = []
            res.data && res.data.map((item) => data.push({taskName: item.interview.title, attData: item.other}))  
            setAttachmentList(data)
          }
      })
    }

    return(
        <div className="taskPicture">
            <Scrollbars style={{ height: 570}}>
                {
                    loading ? <Spin className="loading" /> :
                    attachmentList.length === 0 ? <Empty className="noData" /> : 
                    attachmentList.map((pItem, index) => (
                        <div className="box" key={index}>
                            <div className="part_1">
                                <img src={task} alt="" />
                                <span>{pItem.taskName}</span>
                            </div>
                            <div className="part_2">
                            <UploadItem fileList={pItem.attData}  fileType="附件" showIcon={['download']}/> 
                            </div>
                        </div>
                    ))

                }
            </Scrollbars>
        </div>
    )
}

export default Attachment